import Cross from 'public/cross.svg';
import JustSayCapsule from 'public/just-say-capsule-nba.svg';
import type { NextBestActionCardComponentProps } from 'src/app/types';

import { CloseButtonWrap, CloseCardButton, ImageRow, NBACapsuleCard, TextRow } from '../../styles';

import { JustSayCapsuleSVG, JustSayCapsuleText } from './styles';

const JustSayCapsuleNBACard = ({
  handleCardClick,
  isDismissing,
  handleCloseCardClick,
}: NextBestActionCardComponentProps) => (
  <NBACapsuleCard className="styled-card" onClick={handleCardClick} isDismissing={isDismissing} color={'white'}>
    <ImageRow>
      <JustSayCapsuleSVG src={JustSayCapsule} />
      <CloseButtonWrap onClick={handleCloseCardClick}>
        <CloseCardButton src={Cross} fill={'black'} />
      </CloseButtonWrap>
    </ImageRow>
    <TextRow>
      <JustSayCapsuleText variant="body">
        Whenever your doctor asks what’s your pharmacy, just say “Capsule”.
      </JustSayCapsuleText>
    </TextRow>
  </NBACapsuleCard>
);

export default JustSayCapsuleNBACard;
